function escapeHtml(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export function isMixedSegmentLabel(label) {
  return String(label ?? "").trim().toLowerCase() === "mixed";
}

function readInnerRowLabel(inner) {
  return inner?.label ?? inner?.intent ?? inner?.sentiment ?? "";
}

/**
 * Build HTML for Chart.js external tooltip (stacked bars with mixed inner breakdown).
 */
export function buildStackedBarMixedInnerTooltipHtml({
  styles,
  topicLabel,
  reviewCount,
  segmentRows,
  mixedInnerBreakdown,
  totalReviewsLabel,
  colorForLabel,
}) {
  const safeStyles = styles || {};
  const rows = Array.isArray(segmentRows) ? segmentRows : [];
  const innerRows = Array.isArray(mixedInnerBreakdown) ? mixedInnerBreakdown : [];
  const resolveColor =
    typeof colorForLabel === "function"
      ? colorForLabel
      : () => "rgba(128, 128, 128, 0.8)";

  let html = `<div class="${escapeHtml(safeStyles.intentStackedTooltip)}">`;
  html += `<div class="${escapeHtml(safeStyles.intentStackedTooltipTitle)}">${escapeHtml(topicLabel)}</div>`;
  html += `<div class="${escapeHtml(safeStyles.intentStackedTooltipMeta)}">${escapeHtml(totalReviewsLabel)}: ${escapeHtml(reviewCount)}</div>`;
  html += `<div class="${escapeHtml(safeStyles.intentStackedTooltipRows)}">`;

  for (const row of rows) {
    const label = row?.label ?? "";
    const value = row?.value ?? 0;
    const color = resolveColor(label);
    html += `<div class="${escapeHtml(safeStyles.intentStackedTooltipRow)}">`;
    html += `<span class="${escapeHtml(safeStyles.intentStackedTooltipSwatch)}" style="background-color:${escapeHtml(color)}"></span>`;
    html += `<span class="${escapeHtml(safeStyles.intentStackedTooltipLabel)}">${escapeHtml(label)}</span>`;
    html += `<span class="${escapeHtml(safeStyles.intentStackedTooltipValue)}">${escapeHtml(value)}%</span>`;
    html += `</div>`;

    if (
      isMixedSegmentLabel(label) &&
      Number(value) > 0 &&
      innerRows.length > 0
    ) {
      html += `<div class="${escapeHtml(safeStyles.intentStackedTooltipMixedInner)}">`;
      for (const inner of innerRows) {
        const innerLabel = readInnerRowLabel(inner);
        const innerColor = resolveColor(innerLabel);
        html += `<div class="${escapeHtml(safeStyles.intentStackedTooltipInnerRow)}">`;
        html += `<span class="${escapeHtml(safeStyles.intentStackedTooltipInnerSwatch)}" style="background-color:${escapeHtml(innerColor)}"></span>`;
        html += `<span class="${escapeHtml(safeStyles.intentStackedTooltipInnerLabel)}">${escapeHtml(innerLabel)}</span>`;
        html += `<span class="${escapeHtml(safeStyles.intentStackedTooltipInnerValue)}">${escapeHtml(inner.percentage)}%</span>`;
        html += `</div>`;
      }
      html += `</div>`;
    }
  }

  html += `</div></div>`;
  return html;
}

export function positionStackedBarMixedInnerTooltip(
  tooltipEl,
  canvasRect,
  caretX,
  caretY,
) {
  if (!tooltipEl || !canvasRect) {
    return;
  }
  tooltipEl.style.opacity = "1";
  tooltipEl.style.position = "absolute";
  tooltipEl.style.pointerEvents = "none";
  tooltipEl.style.zIndex = "10000";

  let left = canvasRect.left + window.pageXOffset + caretX + 12;
  let top = canvasRect.top + window.pageYOffset + caretY - 8;

  const maxLeft =
    window.pageXOffset + window.innerWidth - tooltipEl.offsetWidth - 8;
  if (left > maxLeft) {
    left = Math.max(window.pageXOffset + 8, maxLeft);
  }
  if (
    top + tooltipEl.offsetHeight >
    window.pageYOffset + window.innerHeight - 8
  ) {
    top = window.pageYOffset + window.innerHeight - tooltipEl.offsetHeight - 8;
  }

  tooltipEl.style.left = `${left}px`;
  tooltipEl.style.top = `${top}px`;
}
